require('jquery-bar-rating');

var currentRating = $('.js-product-rating');

$(function() {
    for (let i = 0; i < $(currentRating).length; i++) {
        $(currentRating[i]).barrating({
            theme: 'fontawesome-stars-o',
            initialRating: $(currentRating[i]).data('rating'),
            readonly: true
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/bar-rating.js